(($, Drupal) => {
  Drupal.behaviors.readMoreBckgndSlider = {
    attach: function attch(context) {
      addSlider($('.js-readmore-bckgnd-slider'));
      $(window).resize(() => {
        addSlider($('.js-readmore-bckgnd-slider'));
      });

      function addSlider(element) {
        if (window.matchMedia('(max-width: 1024px)').matches) {
          if (!$(element).hasClass('slick-slider')) {
            $(element).slick({
              arrows: false,
              dots: true,
              autoplay: true,
              draggable: true,
              speed: 1000,
              mobileFirst: true,
              slidesToShow: 1,
              variableWidth: true,
            });
          }
        } else if ($(element).hasClass('slick-slider')) {
          const arrayBackground = [];
          const arrayBackgroundBrush = [];
          $('.read-more__item.bckg-column').map(function () {
            arrayBackground.push($(this).css('background-image'));
          });
          $('.read-more__item.bckg-brush-column').map(function () {
            arrayBackgroundBrush.push($(this).css('background-image'));
          });
          $(element).slick('unslick');
          $('.read-more__item.bckg-column').each(function (index) {
            $(this).css('background-image', arrayBackground[index]);
          });
          $('.read-more__item.bckg-brush-column').each(function (index) {
            $(this).css('background-image', arrayBackgroundBrush[index]);
          });
        }
      }
    },
  };
})(jQuery, Drupal);
